import pages from '../../config/pages';
import AnnouncementsManager from '../../pages/Announcements';
import {
  AnnouncementsManagerTab,
  getTabPath,
} from './announcementsManagerPages';

const routes = Object.values(AnnouncementsManagerTab).map((type) => ({
  pageId: pages.COMMUNITY,
  announcementsManagerPath: getTabPath(type),
  component: AnnouncementsManager,
}));

export default routes;
